import SubMenu from "./SubMenu";
import { formatMoney } from "utils";

const Account = ({ account, isSelected, onSelect }) => {

  const reminderData = account.get("reminder");
  const nowTime = new Date().getTime();
  const remindBool = reminderData && nowTime > (new Date(reminderData?.date).getTime() || 0);

  return (
    <li role="button" className={`list-group-item ${isSelected ? "bg-app-light bg-opacity-25" : "bg-transparent border-none"}`}>
      <div className="row fs-5">
        <div className="col-11 py-2 row" onClick={onSelect}>
          <div className={`col-8 col-8 ${account.get("cancelled")
            ? " text-muted text-decoration-line-through"
            : "fw-bold"}`}>
            {remindBool && <i className="bi bi-patch-exclamation-fill text-danger me-2" title="Payment Due!"></i>}
            <span className="fs-6">{account.get("name").length > 50
              ? account.get("name").substring(0, 50) + " ..."
              : account.get("name")}</span>
            <span className="ms-2 badge border-app text-app">
              {account.get("tag")}
            </span>
          </div>
          <div className="col-4 text-end">
            <span className={`fs-6 fw-bold text-nowrap ${account.get("balance") < 0 ? "text-danger" : "text-success"}
              ${account.get("cancelled") ? "text-muted text-decoration-line-through" : ""}`}>
              {formatMoney(Math.abs(account.get("balance")))}
            </span>
          </div>
        </div>
        <div className="col-1">
          <SubMenu account={account} onSelect={onSelect} />
        </div>
      </div>
    </li>
  );
};

export default Account;